import type { ArticleItem, VideoItem } from "@/types/content";

export const formatDuration = (seconds: number): string => {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
};

export const formatViews = (views: number): string => {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)} 万`;
  }
  return String(views);
};

export const formatDate = (date: string): string => {
  return date.replace(/-/g, ".");
};

export const getRelatedVideos = (current: VideoItem, list: VideoItem[]): VideoItem[] => {
  return list
    .filter((item) => item.id !== current.id)
    .map((item) => {
      let score = 0;
      if (item.category === current.category) score += 3;
      item.tags.forEach((tag) => {
        if (current.tags.includes(tag)) score += 2;
      });
      return { item, score };
    })
    .sort((a, b) => b.score - a.score || b.item.heat - a.item.heat)
    .slice(0, 3)
    .map((entry) => entry.item);
};

export const getRelatedArticles = (current: ArticleItem, list: ArticleItem[]): ArticleItem[] => {
  return list
    .filter((item) => item.id !== current.id)
    .map((item) => {
      let score = 0;
      if (item.tag === current.tag) score += 3;
      item.tags.forEach((tag) => {
        if (current.tags.includes(tag)) score += 2;
      });
      return { item, score };
    })
    .sort((a, b) => b.score - a.score || b.item.heat - a.item.heat)
    .slice(0, 3)
    .map((entry) => entry.item);
};